import React, { useState } from "react";
import styles from "./settings.module.scss";
import InfoTopBar from "../common/InfoTopBar/InfoTopBar";
import ToggleSwitch from "./switch";
import ResetPassword from "../Modals/ResetPassword/Reset";
import CurrencyModal from "../Modals/CurrencyModal/CurrencyModal";

const Setting = () => {
  const [selected, setSelected] = useState("USD");
  const [isOpenReset, setIsOpenReset] = useState(false);
  const [isOpenCurrency, setIsOpenCurrency] = useState(false);

  const toggleReset = () => {
    setIsOpenReset(!isOpenReset);
  };
  const toggleCurrency = () => {
    setIsOpenCurrency(!isOpenCurrency);
  };

  return (
    <div className={styles.container}>
      <div style={{ padding: "10px 25px" }}>
        <InfoTopBar heading="Settings" info={false} divider={true}></InfoTopBar>
      </div>

      <div className={styles.container1}>
        <div className={styles.wrapper}>
          <div className={styles.passcode}>
            <div className={styles.left}>
              <img src="/assets/Shape.png" alt="img" />
              <div className={styles.text}>Passcode</div>
            </div>
            <div className={styles.right}>
              <ToggleSwitch label="Notifications" />
            </div>
          </div>

          <div className={styles.currency} onClick={toggleCurrency}>
            <div className={styles.left}>
              <img src="/assets/shap2.png" alt="img" />
              <div className={styles.text}>Default Currency</div>
            </div>
            <div className={styles.right} onClick={toggleCurrency}>
              <div className={styles.text}>{selected}</div>
              <img src="/assets/arow.png" alt="open" />
            </div>
          </div>

          <div className={styles.password} onClick={toggleReset}>
            <div className={styles.left}>
              <img src="/assets/Border.png" alt="img" />
              <div className={styles.text}>Change Password</div>
            </div>
            <div className={styles.right}>
              <img src="/assets/arow.png" alt="open" />
            </div>
          </div>
        </div>
      </div>
      <ResetPassword isOpen={isOpenReset} toggle={toggleReset} />
      <CurrencyModal isOpen={isOpenCurrency} toggle={toggleCurrency} setSelected={setSelected} selected={selected}/>
    </div>
  );
};

export default Setting;
